<template>
  <UIModal v-model="open" transparent close-button back-button fix-header @click="open = false">
    <template #header>
      <div class="modal-header">{{ $t('halloweenNavigationButtonInventory') }}</div>
    </template>

    <div class="modal-body">
      <div class="modal-body-container">
        <ItemCard v-for="(item, index) in inventory" :key="index" :item="item" />
        <ItemCard v-for="index in Array(EMPTY_CARDS).map((_, i) => i)" :key="index" />
      </div>
    </div>
  </UIModal>
</template>

<script lang="ts" setup>
import { type ItemWithQuantity } from '~/types/halloween/items';
import ItemCard from './ItemCard.vue';

const open = defineModel<boolean>({ required: true });
const props = defineProps<{
  inventory: ItemWithQuantity[];
}>();

const EMPTY_CARDS = computed(() => Math.max(0, 12 - props.inventory.length));
</script>
<style scoped>
.modal-body {
  width: 900px;
  max-width: 100%;
  height: 650px;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 0.75rem;
  @media screen and (max-width: 640px) {
    height: 100vh;
  }
}
.modal-body-container {
  position: relative;
  display: flex;
  width: fit-content;
  height: fit-content;
  gap: 10px;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  max-height: 410px;
  overflow: hidden;
  overflow-y: auto;

  @media screen and (max-width: 640px) {
    max-height: calc(100vh - 76px);
    top: 38px;
  }
}
.modal-header {
  position: relative;
  display: grid;
  place-items: center;
  width: 100%;
  font-family: Grenze, serif;
  font-weight: 700;
  font-size: 32px;
  line-height: 30px;
  text-align: center;
  vertical-align: middle;
  color: #fff;
}
</style>
